import { render, staticRenderFns } from "./schoolProjectList.vue?vue&type=template&id=27b0f34d&scoped=true"
import script from "./schoolProjectList.vue?vue&type=script&lang=js"
export * from "./schoolProjectList.vue?vue&type=script&lang=js"
import style0 from "./schoolProjectList.vue?vue&type=style&index=0&id=27b0f34d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0f34d",
  null
  
)

export default component.exports